import { render } from "./post-smtp-button.vue?vue&type=template&id=e27b9696&scoped=true"
import script from "./post-smtp-button.vue?vue&type=script&lang=js"
export * from "./post-smtp-button.vue?vue&type=script&lang=js"

import "./post-smtp-button.vue?vue&type=style&index=0&id=e27b9696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27b9696"]])

export default __exports__